import { IMapGeoObject, Map as NewbuildingMapComponent } from '@cian/frontend-newbuilding-map-component';
import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import {
  ROUTE_LABEL_TYPES,
  TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH,
} from 'shared/constants/transportAccessibilityInfrastructure';
import { selectGeoCoordinates } from 'shared/selectors';
import { TTAInfrastructureItem } from 'shared/types/map';

import { getRouteLabel } from '../utils';

export const useTransportAccessibilityRouting = (mapApi: NewbuildingMapComponent | null) => {
  const routeIdRef = useRef<string>();
  const routeLabelRef = useRef<IMapGeoObject>();

  const mainPinCoordinates = useSelector(selectGeoCoordinates);

  const setTARouting = useCallback(
    async (item: TTAInfrastructureItem) => {
      if (!mainPinCoordinates) {
        return;
      }

      const routeId = `customRoute-${item.id}`;
      routeIdRef.current = routeId;

      await mapApi?.addRoute(
        routeId,
        { coordinates: mainPinCoordinates },
        { coordinates: item.coordinates },
        'pedestrian',
        [0, 0, 0, TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH],
      );

      if (ROUTE_LABEL_TYPES.includes(item.type) && item.title) {
        const routeLabelGeoObject = getRouteLabel({
          id: `${routeId}-label`,
          coordinates: item.coordinates,
          text: item.title,
        });

        routeLabelRef.current = routeLabelGeoObject;
        mapApi?.addGeoObjects([routeLabelGeoObject]);
      }
    },
    [mapApi, mainPinCoordinates],
  );

  const resetTARouting = useCallback(() => {
    if (routeIdRef.current) {
      mapApi?.removeRoute(routeIdRef.current);
      routeIdRef.current = undefined;

      if (routeLabelRef.current) {
        mapApi?.removeGeoObjects([routeLabelRef.current], false);
        routeLabelRef.current = undefined;
      }
    }
  }, [mapApi]);

  return {
    setTARouting,
    resetTARouting,
  };
};
